export default "__VITE_ASSET__AqkLrRBY__"